import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { LAYOUT_NOTES } from '@/constants/campaign-notes';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ScreenFindAiImageStyles, ScreenFindAiStyles } from './FindAi.styles';

const IMAGE_NUMBERS = [1, 2, 3, 4] as const;

export const ScreenFindAi: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'FindAi',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();
  const ethnicity = form.watch('ethnicity');
  const age = form.watch('age');

  const layoutNotes = webCampaign.getLayoutNotes();
  const isRealBoysScreens = layoutNotes.includes(
    LAYOUT_NOTES.TOTAL_REAL_BOYS_SCREENS,
  );

  const getImagePath = (number: number) => {
    if (isRealBoysScreens) {
      return `${S3_BUCKET_URL}/layout-own-ai-man/by_choise/real-boys/${age}-${ethnicity}-${number}.png`;
    }
    return `${S3_BUCKET_URL}/layout-own-ai-man/by_choise/${age}-${ethnicity}-${number}.png`;
  };

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  return (
    <ScreenFindAiStyles>
      <IonContent>
        <div className="images-container">
          {IMAGE_NUMBERS.map((number) => (
            <ScreenFindAiImageStyles key={number}>
              <img src={getImagePath(number)} alt="greet" />
            </ScreenFindAiImageStyles>
          ))}
        </div>
        <OwnAiTitle className="local-title">
          Let's find somebody who is
          <br /> perfect for you!
        </OwnAiTitle>
        <OnboardingSubtitle>
          We have a lot of AI's that met many different preferences for each
          user
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </ScreenFindAiStyles>
  );
};
